import React, { forwardRef, Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';

const AsText = forwardRef(
    (
        {
            id = 'as-text',
            name,
            inputType = 'text',
            title,
            value,
            onChange,
            onClick,
            disabled = false,
            autoComplete = false,
            dataId,
            labelStyle,
            inputStyle,
            disabledStyle,
            maxLength,
            labelProps,
            inputProps,
            style,
            onFocus,
            ...props
        },
        ref
    ) => {
        labelStyle = {
            display: 'block',
            textAlign: 'left',
            color: '#414141',
            ...style,
            ...labelStyle
        };

        disabledStyle = {
            backgroundColor: '#F7F7F7',
            ...disabledStyle
        };

        const submitStyle = {
            color: '#1101BE',
            cursor: 'pointer'
        };

        inputStyle = {
            width: '50%',
            padding: 12,
            border: '1px solid #D7D7D7',
            borderRadius: 5,
            resize: 'vertical',
            contain: 'strict',
            display: 'block',
            textAlign: 'left',
            backgroundColor: '#FFFDF4',
            color: '#414141',
            ...props.style,
            ...inputStyle,
            ...(disabled ? disabledStyle : {}),
            ...(disabled && inputType === 'submit' ? submitStyle : {})
        };

        const handleChange = (event) => {
            if (maxLength && event.target.value.length > maxLength) {
                event.target.value = event.target.value.substring(
                    0,
                    maxLength + 1
                );
            }

            onChange(event);
        };

        const handleClick = (event) => {
            if (disabled) onClick(event);
        };

        // Fix for chromium-based browsers forcing autocomplete
        const handleFocus = useCallback(
            (event) => {
                if (typeof onFocus === 'function') onFocus(event);
                if (autoComplete) return;
                event.target.autocomplete = 'off';
            },
            [autoComplete, onFocus]
        );

        return (
            <Fragment>
                <label
                    {...labelProps}
                    id={`${id}-label`}
                    style={labelStyle}
                    htmlFor={name}
                >
                    {title}
                </label>
                <input
                    {...props}
                    {...inputProps}
                    ref={ref}
                    id={`${id}-input`}
                    style={inputStyle}
                    type={disabled ? inputType : 'text'}
                    name={name}
                    disabled={disabled && inputType === 'text'}
                    value={value || ''}
                    onChange={handleChange}
                    onClick={handleClick}
                    data-id={dataId}
                    maxLength={maxLength}
                    onFocus={handleFocus}
                />
            </Fragment>
        );
    }
);

AsText.displayName = 'AsText';

AsText.defaultProps = {
    id: 'as-text',
    disabled: false,
    autoComplete: false
};

AsText.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.any,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    dataId: PropTypes.string,
    labelStyle: PropTypes.object,
    maxLength: PropTypes.number,
    labelProps: PropTypes.object,
    inputProps: PropTypes.object,
    style: PropTypes.object,
    autoComplete: PropTypes.bool,
    onFocus: PropTypes.func,
    disabledStyle: PropTypes.object
};

export default AsText;
